import React, { useState, useEffect } from 'react';
import { LayoutDashboard, Calendar, MapPin, Gift, Camera, Users, Settings, LogOut, Menu, X, Heart, Home, Wallet, Plane } from 'lucide-react';
import axios from 'axios';
import './AdminApp.css';

// Import all components
import { 
  AdminLogin, 
  Dashboard, 
  WebsiteSettings, 
  EventManagement, 
  VenueManagement, 
  GiftManagement, 
  GalleryManagement, 
  RSVPManagement, 
  AccommodationManager,
  PledgeManagement,
  TravelGuideManagement
} from './components/admin';

// Import API config
import API_ENDPOINTS from './config/api';

const AdminApp = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [currentPage, setCurrentPage] = useState('dashboard');

  useEffect(() => { checkAuth(); }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.ADMIN_CHECK);
      if (response.data.success) setIsAuthenticated(true);
    } catch (error) { console.error('Auth check failed:', error); }
  };

  const handleLogout = async () => {
    await axios.post(API_ENDPOINTS.ADMIN_LOGOUT);
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) return <AdminLogin onLogin={() => setIsAuthenticated(true)} />;

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'events', label: 'Events & Schedule', icon: Calendar },
    { id: 'venue', label: 'Venue', icon: MapPin },
    { id: 'gifts', label: 'Gift Registry', icon: Gift },
    { id: 'pledges', label: 'Pledges', icon: Wallet },
    { id: 'gallery', label: 'Gallery', icon: Camera },
    { id: 'rsvp', label: 'RSVP Management', icon: Users },
    { id: 'accommodation', label: 'Accommodation', icon: Home },
    { id: 'travel', label: 'Travel Guide', icon: Plane },
    { id: 'settings', label: 'Website Settings', icon: Settings }
  ];

  const renderPage = () => {
    switch(currentPage) {
      case 'dashboard': return <Dashboard />;
      case 'events': return <EventManagement />;
      case 'venue': return <VenueManagement />;
      case 'gifts': return <GiftManagement />;
      case 'pledges': return <PledgeManagement />;
      case 'gallery': return <GalleryManagement />;
      case 'rsvp': return <RSVPManagement />;
      case 'accommodation': return <AccommodationManager />;
      case 'travel': return <TravelGuideManagement />;
      case 'settings': return <WebsiteSettings />;
      default: return <Dashboard />;
    }
  };

  return (
    <div className="admin-app">
      <div className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <Heart size={30} color="#e91e63" />
          {sidebarOpen && <h2>Wedding Admin</h2>}
          <button className="toggle-sidebar" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map(item => (
            <button key={item.id} className={`nav-item ${currentPage === item.id ? 'active' : ''}`} onClick={() => setCurrentPage(item.id)}>
              <item.icon size={20} />
              {sidebarOpen && <span>{item.label}</span>}
            </button>
          ))}
          <button className="nav-item logout" onClick={handleLogout}>
            <LogOut size={20} />
            {sidebarOpen && <span>Logout</span>}
          </button>
        </nav>
      </div>
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="main-header"><h1>{menuItems.find(item => item.id === currentPage)?.label}</h1></div>
        <div className="content-area">{renderPage()}</div>
      </div>
    </div>
  );
};

export default AdminApp;